import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { AiOutlineScan } from "react-icons/ai";
import OfflinePage from "../OfflinePage/OfflinePage";
import UserGreeting from "../../components/UserGreeting/UserGreeting";
import BarcodeScanner from "../../components/BarcodeScanner/BarcodeScanner";
import { BsUpcScan } from "react-icons/bs";
import {
  Alert,
  Button,
  Drawer,
  Form,
  Input,
  message,
  Modal,
  Table,
  Tag,
} from "antd";
import { FiSearch } from "react-icons/fi";
import { getOrderIDScanThunk } from "../../redux/ScannerRedux/Action";

import {
  createOrderClickPostThunk,
  callSrCreateOrderThunk,
  generateAwbNbrStickerThunk,
  generatePaymentPendingPdfThunk,
  printPdfThunk,
} from "../../redux/dispatchRedux/Action";
import { selectPrinterByDesk } from "../../components/helper/deskData";

export class DispatchPage extends Component {
  state = {
    showScannerScreen: false,
    autoScanModal: false,
    autoScanBoxNumber: "",
    autoScanBoxIds: [],
    alreadyPrintedModal: false,
    alreadyPrinted: false,
    // scan: true,
  };

  myRef = React.createRef();

  updateBoxId = (value) => {
    this.setState({ showScannerScreen: false });
  };

  //? Gunscanner subfunctions
  generateAwbNbrSticker = (params) => {
    this.props.generateAwbNbrStickerThunk(params).then(() => {
      message.destroy();
      if (this.props.dispatchDetails.awbStickerError) {
        message.error(this.props.dispatchDetails.awbStickerError, 2);
        let boxIds = this.state.autoScanBoxIds;

        boxIds.push({
          boxNumber: this.state.autoScanBoxNumber,
          status: false,
        });

        this.setState({ autoScanBoxIds: boxIds, autoScanBoxNumber: "" });
      } else if (this.props.dispatchDetails.awbStickerDetails) {
        message.loading("Printing...", 0);
        let printerData = {
          printerDetails: {
            printerId: selectPrinterByDesk(
              this.props.checkerDetails?.deskDetails?.deskDetailsList,
              this.props.deskNumber
            ),
            contentType: "pdf_uri",
            content: this.props.dispatchDetails.awbStickerDetails,
            title:
              this.props.scannerData.scannedOrderIDOrderDetailsSuccess.orderId +
              " - Sticker",
            source: "Dispatch",
          },
          history: this.props.history,
        };
        this.startPrinting(printerData);
      } else {
        message.error("No URL found", 2);
        let boxIds = this.state.autoScanBoxIds;

        boxIds.push({
          boxNumber: this.state.autoScanBoxNumber,
          status: false,
        });

        this.setState({ autoScanBoxIds: boxIds, autoScanBoxNumber: "" });
      }
    });
  };

  startPrinting = (printerData) => {
    this.props.printPdfThunk(printerData).then(() => {
      message.destroy();
      if (this.props.dispatchDetails.printerError) {
        message.error(this.props.dispatchDetails.printerError, 2);
        let boxIds = this.state.autoScanBoxIds;

        boxIds.push({
          boxNumber: this.state.autoScanBoxNumber,
          status: false,
        });

        this.setState({ autoScanBoxIds: boxIds, autoScanBoxNumber: "" });
      } else if (this.props.dispatchDetails.printerDetails) {
        message.success("Done", 1);
        setTimeout(() => {
          //? on success push ids into table
          let boxIds = this.state.autoScanBoxIds;

          boxIds.push({
            boxNumber: this.state.autoScanBoxNumber,
            status: true,
          });

          this.setState({ autoScanBoxIds: boxIds, autoScanBoxNumber: "" });
        }, 250);
      } else {
        message.error("Unknown error", 2);
        let boxIds = this.state.autoScanBoxIds;

        boxIds.push({
          boxNumber: this.state.autoScanBoxNumber,
          status: false,
        });

        this.setState({ autoScanBoxIds: boxIds, autoScanBoxNumber: "" });
      }
    });
  };

  generatePaymentPendingPdf = (params) => {
    this.props.generatePaymentPendingPdfThunk(params).then(() => {
      message.destroy();
      if (this.props.dispatchDetails.paymentPendingError) {
        message.error(this.props.dispatchDetails.paymentPendingError, 2);
        let boxIds = this.state.autoScanBoxIds;

        boxIds.push({
          boxNumber: this.state.autoScanBoxNumber,
          status: false,
        });

        this.setState({ autoScanBoxIds: boxIds, autoScanBoxNumber: "" });
      } else if (this.props.dispatchDetails.paymentPendingDetails) {
        message.loading("Printing...", 0);
        let printerData = {
          printerDetails: {
            printerId: selectPrinterByDesk(
              this.props.checkerDetails?.deskDetails?.deskDetailsList,
              this.props.deskNumber
            ),
            contentType: "pdf_uri",
            content: this.props.dispatchDetails.paymentPendingDetails,
            title:
              this.props.scannerData.scannedOrderIDOrderDetailsSuccess.orderId +
              " - Sticker",
            source: "Dispatch",
          },
          history: this.props.history,
        };
        this.startPrinting(printerData);
      } else {
        message.error("No URL found", 2);
        let boxIds = this.state.autoScanBoxIds;

        boxIds.push({
          boxNumber: this.state.autoScanBoxNumber,
          status: false,
        });

        this.setState({ autoScanBoxIds: boxIds, autoScanBoxNumber: "" });
      }
    });
  };

  onScanChange = (e) => {
    this.setState({ autoScanBoxNumber: e.target.value });
  };

  //? Gun Scanner function
  autoScanFunc = (e) => {
    if (e.key === "Enter") {
      if (!this.props.deskNumber) {
        message.error("Please select desk to print the sticker", 2);
      } else if (
        this.state.autoScanBoxNumber &&
        this.state.autoScanBoxNumber.length > 2
      ) {
        let data = {
          access_token: this.props.access_token,
          history: this.props.history,
          boxNumber: this.state.autoScanBoxNumber,
        };
        this.props.getOrderIDScanThunk(data).then(() => {
          // this.setState({ scan: true });
          if (this.props.scannerData.scannedOrderIDOrderError) {
            message.error(this.props.scannerData.scannedOrderIDOrderError, 2);
            this.setState({
              autoScanBoxNumber: "",
            });
          } else if (
            this.props.scannerData?.scannedOrderIDOrderDetailsSuccess?.orderId
          ) {
            //? Dispatch auto print flow
            if (
              this.props.scannerData.scannedOrderIDOrderDetailsSuccess
                ?.packageDetailsTracking?.awbNoPrinted &&
              !this.state.alreadyPrinted
            ) {
              this.setState({ alreadyPrintedModal: true });
            } else {
              message.loading("Fetching Details...", 0);
              let params = {
                access_token: this.props.access_token,
                orderId: this.props.scannerData
                  .scannedOrderIDOrderDetailsSuccess.orderId,
                history: this.props.history,
              };
              if (
                this.props.scannerData.scannedOrderIDOrderDetailsSuccess?.awbNo
              ) {
                this.generateAwbNbrSticker(params);
              } else if (
                !this.props.scannerData.scannedOrderIDOrderDetailsSuccess
                  ?.awbNo &&
                this.props.scannerData.scannedOrderIDOrderDetailsSuccess
                  ?.orderStatus?.serialId === 66
              ) {
                message.loading("Please wait...", 0);
                let cpSrData = {
                  access_token: this.props.access_token,
                  createOrderReq: {
                    orderId: this.props.scannerData
                      .scannedOrderIDOrderDetailsSuccess?.orderId,
                    transactionId: this.props.scannerData
                      .scannedOrderIDOrderDetailsSuccess?.orderId,
                    invoiceNo: this.props.scannerData
                      .scannedOrderIDOrderDetailsSuccess?.packageDetailsTracking
                      ?.invoiceNumber,
                    invoiceDate: this.props.scannerData
                      .scannedOrderIDOrderDetailsSuccess?.packageDetailsTracking
                      ?.invoiceDate,
                    courierPartnerId: this.props.scannerData
                      .scannedOrderIDOrderDetailsSuccess?.packageDetailsTracking
                      ?.courierPartnerId,
                    courierPartner: this.props.scannerData
                      .scannedOrderIDOrderDetailsSuccess?.packageDetailsTracking
                      ?.courierPartnerAccountCode,
                    courierPartnerName: this.props.scannerData
                      .scannedOrderIDOrderDetailsSuccess?.packageDetailsTracking
                      ?.courierPartnerAccountCode,
                  },
                };
                if (
                  this.props.scannerData.scannedOrderIDOrderDetailsSuccess
                    ?.packageDetailsTracking?.shippingPartnerId === 255
                ) {
                  this.props.createOrderClickPostThunk(cpSrData).then(() => {
                    message.destroy();
                    if (this.props.dispatchDetails?.cpError) {
                      message.error(this.props.dispatchDetails?.cpError, 2);
                      this.setState({
                        autoScanBoxNumber: "",
                      });
                    } else if (
                      this.props.dispatchDetails?.cpSuccess?.meta?.message ===
                      "We are processing your order"
                    ) {
                      message.error("Please try again after 5 mins");
                      this.setState({
                        autoScanBoxNumber: "",
                      });
                    } else {
                      this.autoScanFunc(this.state.autoScanBoxNumber);
                    }
                  });
                } else if (
                  this.props.scannerData.scannedOrderIDOrderDetailsSuccess
                    ?.packageDetailsTracking?.shippingPartnerId === 256
                ) {
                  this.props.callSrCreateOrderThunk(cpSrData).then(() => {
                    message.destroy();
                    if (this.props.dispatchDetails?.srError) {
                      message.error(this.props.dispatchDetails?.srError, 2);
                      this.setState({
                        autoScanBoxNumber: "",
                      });
                    } else {
                      this.autoScanFunc(this.state.autoScanBoxNumber);
                    }
                  });
                } else {
                  message.error("No shipping partner found", 2);
                  let boxIds = this.state.autoScanBoxIds;
                  boxIds.push({
                    boxNumber: this.state.autoScanBoxNumber,
                    status: false,
                  });
                  this.setState({
                    autoScanBoxIds: boxIds,
                    autoScanBoxNumber: "",
                  });
                }
              } else if (
                this.props.scannerData.scannedOrderIDOrderDetailsSuccess
                  ?.orderStatus?.serialId === 58
              ) {
                this.generatePaymentPendingPdf(params);
              } else {
                message.error(
                  "AWB number not generated. Please try again after some time."
                );
                let boxIds = this.state.autoScanBoxIds;
                boxIds.push({
                  boxNumber: this.state.autoScanBoxNumber,
                  status: false,
                });
                this.setState({
                  autoScanBoxIds: boxIds,
                  autoScanBoxNumber: "",
                });
              }
            }
          }
        });
        // ? Service call to print ids
      }
      // });
      // }
      // }, 2000);
    }
  };

  autoScanCancelFunc = () => {
    this.setState({ autoScanModal: false, autoScanBoxIds: [] });
  };

  setFocus = (isOpen) => {
    isOpen && this.myRef.current.focus();
  };

  ////? Table search filter
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          //  icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <FiSearch style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    //  render: (text) => (
    //    <Highlighter
    //      highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
    //      searchWords={[this.state.searchText]}
    //      autoEscape
    //      textToHighlight={text.toString()}
    //    />
    //  ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  // - Ends //
  render() {
    const columns = [
      {
        title: "Scanned Box Numbers",
        dataIndex: "boxNumber",
        key: "boxNumber",
        ...this.getColumnSearchProps("boxNumber"),
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
      {
        title: "Print Status",
        dataIndex: "status",
        key: "status",
        ...this.getColumnSearchProps("status"),
        render: (text) => {
          return {
            children: (
              <span>
                {text ? (
                  <Tag color="green">Success</Tag>
                ) : (
                  <Tag color="red">Failed</Tag>
                )}
              </span>
            ),
          };
        },
      },
    ];
    return (
      <div>
        {this.props.isOnline ? (
          <div className="centerScreen">
            <UserGreeting />
            <div style={{ marginTop: "150px" }}>
              <button
                className="bbtn"
                onClick={() => this.setState({ showScannerScreen: true })}
              >
                <AiOutlineScan /> Scan the barcode
              </button>
            </div>
            {this.state.showScannerScreen && (
              <BarcodeScanner
                scan={this.state.showScannerScreen}
                camera={this.state.showScannerScreen}
                redirect="dispatch"
                history={this.props.history}
                getBoxId={this.updateBoxId}
              />
            )}

            <button
              className="bbtn"
              onClick={() => this.setState({ autoScanModal: true })}
              style={{ marginTop: "1em" }}
            >
              <BsUpcScan /> Use Gun Scanner
            </button>

            <Drawer
              title="Scan the Barcode"
              placement="right"
              className="BarcodeDrawer"
              onClose={this.autoScanCancelFunc}
              maskClosable={false}
              visible={this.state.autoScanModal}
              afterVisibleChange={this.setFocus}
            >
              <Form.Item label="Box Number">
                <Input
                  value={this.state.autoScanBoxNumber}
                  onChange={this.onScanChange}
                  onKeyDown={this.autoScanFunc}
                  ref={this.myRef}
                />
              </Form.Item>

              <br />

              {this.state.autoScanBoxIds &&
                this.state.autoScanBoxIds.length > 0 && (
                  <Table
                    dataSource={[...this.state.autoScanBoxIds]}
                    columns={columns}
                    pagination={
                      this.state.autoScanBoxIds?.length > 10 ? true : false
                    }
                    bordered
                    scroll={{ x: 700 }}
                  />
                )}
            </Drawer>

            <Modal
              title={`Do you want to print again?`}
              visible={this.state.alreadyPrintedModal}
              // centered
              onOk={() =>
                this.setState(
                  { alreadyPrintedModal: false, alreadyPrinted: true },
                  () => {
                    this.autoScanFunc(this.state.autoScanBoxNumber);
                  }
                )
              }
              onCancel={() => this.setState({ alreadyPrintedModal: false })}
            >
              <Alert
                message="Sticker already printed"
                type="warning"
                showIcon
              />
            </Modal>
          </div>
        ) : (
          <OfflinePage />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  scannerData: state.scannerReducer,
  dispatchDetails: state.dispatchReducer,
  checkerDetails: state.newCheckerOrderReducer,
  deskNumber: state.statusReducer?.deskNumber,
});

export default withRouter(
  connect(mapStateToProps, {
    getOrderIDScanThunk,
    createOrderClickPostThunk,
    callSrCreateOrderThunk,
    generateAwbNbrStickerThunk,
    generatePaymentPendingPdfThunk,
    printPdfThunk,
  })(DispatchPage)
);
